var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "create-box-page", class: { mobile: _vm.$screen.mobile } },
    [
      _c("div", { staticClass: "header" }, [
        _c("span", {
          staticClass: "header-back el-icon-arrow-left",
          on: { click: _vm.onBack },
        }),
        _c("h1", { staticClass: "header-title" }, [_vm._v("自建盲盒")]),
      ]),
      _c("div", { staticClass: "create-box-header-info" }, [
        _c("span", [_vm._v("当前VIP等级: " + _vm._s(_vm.vipLevelText))]),
        _c("span", [_vm._v("可创建箱子: " + _vm._s(_vm.createLimit) + "个")]),
        _c("span", [_vm._v("剩余可创建: " + _vm._s(_vm.remainCreate) + "个")]),
      ]),
      _c("div", { staticClass: "create-box-container" }, [
        _c("div", { staticClass: "section section-name" }, [
          _vm._m(0),
          _c("div", { staticClass: "name-input-wrap" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.boxName,
                  expression: "boxName",
                },
              ],
              staticClass: "name-input",
              attrs: {
                type: "text",
                placeholder: "请输入箱子名称",
                maxlength: "20",
              },
              domProps: { value: _vm.boxName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.boxName = $event.target.value
                },
              },
            }),
          ]),
          _c("p", { staticClass: "name-hint" }, [
            _vm._v("只支持字母和中文 20个字符以内"),
          ]),
        ]),
        _c("div", { staticClass: "section section-style" }, [
          _vm._m(1),
          _c("div", { staticClass: "style-content flex" }, [
            _c("div", { staticClass: "style-preview" }, [
              _vm.caseImgList.length
                ? _c("div", { staticClass: "preview-wrap" }, [
                    _c("img", {
                      attrs: {
                        src: _vm._f("imgfilter")(
                          _vm.selectedStyle &&
                            (_vm.selectedStyle.imgUrl ||
                              _vm.selectedStyle.casePic ||
                              _vm.selectedStyle.picture)
                        ),
                        alt: "",
                      },
                    }),
                  ])
                : _c(
                    "div",
                    { staticClass: "preview-wrap preview-placeholder" },
                    [_c("span", [_vm._v("请选择样式")])]
                  ),
            ]),
            _c("div", { staticClass: "style-grid-wrap" }, [
              _vm.caseImgList.length
                ? _c(
                    "div",
                    { staticClass: "style-grid" },
                    _vm._l(_vm.caseImgList, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: item.id || index,
                          staticClass: "style-item",
                          class: {
                            active:
                              _vm.selectedStyle &&
                              (_vm.selectedStyle.id === item.id ||
                                _vm.selectedStyle === item),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onSelectStyle(item)
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm._f("imgfilter")(
                                item.imgUrl || item.casePic || item
                              ),
                              alt: "",
                            },
                          }),
                        ]
                      )
                    }),
                    0
                  )
                : _vm.loading
                ? _c("div", { staticClass: "style-loading" }, [
                    _vm._v("加载中..."),
                  ])
                : _c("div", { staticClass: "style-empty" }, [
                    _vm._v("暂无箱子样式"),
                  ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "section section-range" }, [
          _c(
            "h2",
            { staticClass: "section-title" },
            [
              _c("span", { staticClass: "step-num" }, [_vm._v("03")]),
              _c("span", { staticClass: "step-text" }, [_vm._v("箱子收益")]),
              _c(
                "el-popover",
                {
                  attrs: {
                    placement: "top",
                    width: "220",
                    trigger: "click",
                    content:
                      "所创建的箱子，每被开启一次，可获得门票价值的抽成百分比奖励",
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-icon-question",
                    staticStyle: {
                      color: "#f5b844",
                      cursor: "pointer",
                      "margin-left": "4px",
                      "font-size": "14px",
                    },
                    attrs: { slot: "reference" },
                    slot: "reference",
                  }),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "range-control-group" }, [
            _c("span", { staticClass: "range-label" }, [_vm._v("比例")]),
            _c("div", { staticClass: "range-value-display" }, [
              _c("span", { staticClass: "num" }, [
                _vm._v(_vm._s(_vm.defaultRangeValue)),
              ]),
              _c("span", { staticClass: "unit" }, [_vm._v("%")]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "section section-mall" }, [
          _vm._m(2),
          _c("div", { staticClass: "mall-search-filter-bar" }, [
            _c("div", { staticClass: "filter-input-item" }, [
              _c("label", [_vm._v("售价区间")]),
              _c("div", { staticClass: "price-range-inputs" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.minprice,
                      expression: "minprice",
                    },
                  ],
                  attrs: { type: "number", placeholder: "最小" },
                  domProps: { value: _vm.minprice },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.minprice = $event.target.value
                    },
                  },
                }),
                _c("span", { staticClass: "split-line" }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.maxprice,
                      expression: "maxprice",
                    },
                  ],
                  attrs: { type: "number", placeholder: "最大" },
                  domProps: { value: _vm.maxprice },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.maxprice = $event.target.value
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "filter-input-item" }, [
              _c("label", [_vm._v("关键词")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchKeyword,
                    expression: "searchKeyword",
                  },
                ],
                staticClass: "keyword-search-input",
                attrs: { type: "text", placeholder: "输入物品名称搜索..." },
                domProps: { value: _vm.searchKeyword },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.onSearchPrice.apply(null, arguments)
                  },
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchKeyword = $event.target.value
                  },
                },
              }),
            ]),
            _c(
              "button",
              {
                staticClass: "btn-search-execute",
                attrs: { type: "button" },
                on: { click: _vm.onSearchPrice },
              },
              [_vm._v("搜索")]
            ),
          ]),
          _c(
            "div",
            { staticClass: "mall-category-tabs" },
            _vm._l(_vm.itemCategories, function (item, idx) {
              return _c(
                "div",
                {
                  key: idx,
                  staticClass: "tab-item",
                  class: { active: _vm.itemCategory === item.value },
                  on: {
                    click: function ($event) {
                      _vm.itemCategory = item.value
                    },
                  },
                },
                [_vm._v(" " + _vm._s(item.label) + " ")]
              )
            }),
            0
          ),
          _vm.filteredItemList.length
            ? _c(
                "div",
                { staticClass: "mall-goods-grid" },
                _vm._l(_vm.filteredItemList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "goods-card",
                      class: { selected: _vm.isItemSelected(item) },
                      on: {
                        click: function ($event) {
                          return _vm.toggleSelectItem(item)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "select-badge" }),
                      _c("div", { staticClass: "goods-img-wrap" }, [
                        _c("img", { attrs: { src: item.pic || item.imgUrl } }),
                        item.isNonSale
                          ? _c("span", { staticClass: "item-tag non-sale" }, [
                              _vm._v("非卖品"),
                            ])
                          : _vm._e(),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "goods-title",
                          attrs: { title: item.name },
                        },
                        [_vm._v(_vm._s(item.name))]
                      ),
                      _c("div", { staticClass: "goods-price" }, [
                        _vm._v("$" + _vm._s(item.price)),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _c("div", { staticClass: "none-item" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/none-item.svg"),
                    alt: "暂无数据",
                  },
                }),
                _c("div", [_vm._v("没有找到相关的皮肤物品")]),
              ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.totalItems > 0 && !_vm.itemsLoading,
                  expression: "totalItems > 0 && !itemsLoading",
                },
              ],
              staticClass: "pagination-container",
            },
            [
              _c("el-pagination", {
                attrs: {
                  layout: "prev, pager, next",
                  "current-page": _vm.page,
                  "page-size": _vm.pageSize,
                  total: _vm.totalItems,
                },
                on: { "current-change": _vm.handlePageChange },
              }),
            ],
            1
          ),
          _c("p", { staticClass: "vip-limit-hint" }, [
            _vm._v("当前VIP等级可选饰品的最高价值: " + _vm._s(_vm.vipMaxValue)),
          ]),
        ]),
        _c("div", { staticClass: "section section-prob" }, [
          _vm._m(3),
          _c("div", { staticClass: "prob-table-wrapper" }, [
            _c("table", { staticClass: "prob-table" }, [
              _vm._m(4),
              _c(
                "tbody",
                _vm._l(_vm.probabilityList, function (item, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [
                      _c("img", {
                        staticClass: "goods-img-mini",
                        attrs: {
                          src:
                            item.pic ||
                            item.imgUrl ||
                            item.itemPic ||
                            item.casePic,
                        },
                      }),
                    ]),
                    _c("td", [
                      _c(
                        "div",
                        {
                          staticClass: "goods-name-cell",
                          attrs: { title: item.name },
                        },
                        [_vm._v(_vm._s(item.name))]
                      ),
                    ]),
                    _c("td", [
                      _c("span", { staticClass: "price-val" }, [
                        _vm._v("$" + _vm._s(item.price)),
                      ]),
                    ]),
                    _c("td", [
                      _c("span", { staticClass: "prob-input-counter" }, [
                        _c(
                          "button",
                          {
                            staticClass: "counter-btn",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.decreaseProb(index)
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "10",
                                  height: "2",
                                  viewBox: "0 0 12 2",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M0 1C0 0.447715 0.447715 0 1 0H11C11.5523 0 12 0.447715 12 1C12 1.55228 11.5523 2 11 2H1C0.447716 2 0 1.55228 0 1Z",
                                    fill: "currentColor",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: item.probability,
                              expression: "item.probability",
                              modifiers: { number: true },
                            },
                          ],
                          attrs: { type: "number" },
                          domProps: { value: item.probability },
                          on: {
                            blur: [
                              function ($event) {
                                return _vm.validateProb(index)
                              },
                              function ($event) {
                                return _vm.$forceUpdate()
                              },
                            ],
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                item,
                                "probability",
                                _vm._n($event.target.value)
                              )
                            },
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "rgba(245, 184, 68, 0.4)",
                              "padding-right": "8px",
                              "font-size": "12px",
                              "font-family": "monospace",
                            },
                          },
                          [_vm._v("%")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "counter-btn",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.increaseProb(index)
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "10",
                                  height: "10",
                                  viewBox: "0 0 12 12",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M5 11V7H1C0.447715 7 0 6.55228 0 6C0 5.44772 0.447715 5 1 5H5V1C5 0.447715 5.44772 0 6 0C6.55228 0 7 0.447715 7 1V5H11C11.5523 5 12 5.44772 12 6C12 6.55228 11.5523 7 11 7H7V11C7 11.5523 6.55228 12 6 12C5.44772 12 5 11.5523 5 11Z",
                                    fill: "currentColor",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("td", [
                      _c(
                        "button",
                        {
                          staticClass: "prob-btn-del",
                          attrs: { type: "button", title: "溢出池" },
                          on: {
                            click: function ($event) {
                              return _vm.removeProbabilityRow(index)
                            },
                          },
                        },
                        [_c("i", { staticClass: "el-icon-delete" })]
                      ),
                    ]),
                  ])
                }),
                0
              ),
            ]),
          ]),
          _c("div", { staticClass: "prob-summary flex flex-wrap" }, [
            _c("span", { staticClass: "prob-total" }, [
              _vm._v("概率总和: " + _vm._s(_vm.totalProbability) + "%"),
            ]),
            _vm.totalProbability !== 100
              ? _c("span", { staticClass: "prob-err" }, [
                  _vm._v(
                    "您当前设置概率" +
                      _vm._s(_vm.totalProbability) +
                      "% (必须满100%)"
                  ),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "finance-box" }, [
            _c("p", [
              _vm._v("您当前的盒子每次开箱的售价: "),
              _c("span", { staticClass: "price-val" }, [
                _vm._v("$" + _vm._s(_vm.boxSalePrice)),
              ]),
            ]),
            _c("p", [
              _vm._v("每次开箱预计收益: "),
              _c("span", { staticClass: "price-val" }, [
                _vm._v("$" + _vm._s(_vm.boxProfit)),
              ]),
            ]),
          ]),
          _c("p", { staticClass: "create-limit-hint" }, [
            _vm._v(" 您最多可创建 "),
            _c("span", { staticClass: "price-val" }, [
              _vm._v(_vm._s(_vm.createLimit)),
            ]),
            _vm._v(" 个箱子， 已创建 "),
            _c("span", { staticClass: "price-val" }, [
              _vm._v(_vm._s(_vm.createdCount)),
            ]),
            _vm._v(" 个， 还剩 "),
            _c("span", { staticClass: "price-val" }, [
              _vm._v(_vm._s(_vm.remainCreate)),
            ]),
            _vm._v(" 个 "),
          ]),
          _c("div", { staticClass: "submit-wrap" }, [
            _c(
              "button",
              {
                staticClass: "btn-confirm",
                attrs: { type: "button" },
                on: { click: _vm.onConfirm },
              },
              [_vm._v("确定")]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "section-title" }, [
      _c("span", { staticClass: "step-num" }, [_vm._v("01")]),
      _c("span", { staticClass: "step-text" }, [_vm._v("创建箱子的名称")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "section-title" }, [
      _c("span", { staticClass: "step-num" }, [_vm._v("02")]),
      _c("span", { staticClass: "step-text" }, [_vm._v("选择箱子的样式")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "section-title" }, [
      _c("span", { staticClass: "step-num" }, [_vm._v("04")]),
      _c("span", { staticClass: "step-text" }, [_vm._v("选择物品")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "section-title" }, [
      _c("span", { staticClass: "step-num" }, [_vm._v("05")]),
      _c("span", { staticClass: "step-text" }, [
        _vm._v("已选物品概率及收益核算"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("物品图片")]),
        _c("th", [_vm._v("物品名称")]),
        _c("th", [_vm._v("价值/售价")]),
        _c("th", [_vm._v("中奖概率配置")]),
        _c("th", [_vm._v("操作")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }